import { Box, MenuItem, Select, TextField, Typography } from '@mui/material';
import {
  ChannelTabs,
  DurationField,
} from 'components/@home/@settings/Tabs/Agents/panels/ChannelTabs';
import {
  SettingsToggleRow,
  useConfigurationSectionSx,
} from 'components/@home/@settings/Tabs/Agents/panels/configurationSectionStyles';
import { normalizeTimeoutSettings } from 'components/@home/@settings/Tabs/Agents/panels/timeoutDefaults';
import { func, object } from 'prop-types';
import React, { useState } from 'react';
import { I18n } from 'utils/i18n';

const ConversationTimeLimitCard = ({ draft, onPatch }) => {
  const sx = useConfigurationSectionSx();
  const [channel, setChannel] = useState('chat');
  const [unit, setUnit] = useState('minutes');
  const ts = normalizeTimeoutSettings(draft.timeoutSettings);
  const ctl = ts[channel].conversationTimeLimit;

  const patch = next => {
    onPatch('timeoutSettings', {
      ...ts,
      [channel]: { ...ts[channel], conversationTimeLimit: { ...ctl, ...next } },
    });
  };

  return (
    <Box sx={[sx.section, sx.card]}>
      <Typography sx={sx.sectionTitle}>{I18n.t('AgenticChatFlow.ConvTimeLimitTitle')}</Typography>
      <Typography sx={sx.sectionHelper}>{I18n.t('AgenticChatFlow.ConvTimeLimitHelper')}</Typography>
      <ChannelTabs channel={channel} onChange={setChannel} />
      <SettingsToggleRow
        label={I18n.t('AgenticChatFlow.ConvTimeLimitEnable')}
        checked={Boolean(ctl.enabled)}
        onChange={e => patch({ enabled: e.target.checked })}
      />
      <Box sx={sx.sectionDivider} />
      <Box sx={sx.fieldsStack}>
        <Box>
          <Typography sx={sx.fieldLabel}>{I18n.t('AgenticChatFlow.TimeoutAfter')}</Typography>
          <DurationField
            seconds={ctl.durationSeconds}
            unit={unit}
            onChangeSeconds={s => patch({ durationSeconds: s })}
            onChangeUnit={setUnit}
          />
        </Box>
        <Box>
          <Typography sx={sx.fieldLabel}>{I18n.t('AgenticChatFlow.DestinationType')}</Typography>
          <Select
            size="small"
            fullWidth
            value={ctl.destinationType || 'end'}
            onChange={e => patch({ destinationType: e.target.value })}
          >
            <MenuItem value="end">{I18n.t('AgenticChatFlow.DestinationEnd')}</MenuItem>
            <MenuItem value="forward">{I18n.t('AgenticChatFlow.DestinationForward')}</MenuItem>
          </Select>
        </Box>
        {ctl.destinationType === 'forward' && (
          <Box>
            <Typography sx={sx.fieldLabel}>{I18n.t('AgenticChatFlow.ForwardTo')}</Typography>
            <TextField
              size="small"
              fullWidth
              value={ctl.forwardTo || ''}
              onChange={e => patch({ forwardTo: e.target.value })}
            />
          </Box>
        )}
        <Box>
          <SettingsToggleRow
            label={I18n.t('AgenticChatFlow.AgentMessageBeforeEnding')}
            checked={Boolean(ctl.agentMessageBeforeEnding?.enabled)}
            onChange={e =>
              patch({
                agentMessageBeforeEnding: {
                  ...ctl.agentMessageBeforeEnding,
                  enabled: e.target.checked,
                },
              })
            }
          />
          <TextField
            size="small"
            fullWidth
            multiline
            minRows={2}
            sx={{ mt: 1.5 }}
            value={ctl.agentMessageBeforeEnding?.message || ''}
            onChange={e =>
              patch({
                agentMessageBeforeEnding: {
                  ...ctl.agentMessageBeforeEnding,
                  message: e.target.value,
                },
              })
            }
            placeholder={I18n.t('AgenticChatFlow.AgentMessageBeforeEndingPlaceholder')}
          />
        </Box>
      </Box>
    </Box>
  );
};

ConversationTimeLimitCard.propTypes = { draft: object.isRequired, onPatch: func.isRequired };

export default ConversationTimeLimitCard;
